var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"container",staticClass:"scrollable-container-outer",style:(_vm.style)},[_c('div',{staticClass:"scrollable-container-inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }